@if (!!vm()) {
    <div
        class="mybets-scoreboard_stats"
        [ngClass]="{ 'mybets-scoreboard_stats-expanded': isExpanded(), 'mybets-scoreboard_stats-collapsed': !isExpanded() }">
        <div class="mybets-scoreboard_stats-values mybets-scoreboard_stats-values-pair">
            @for (stat of vm().list; track $index) {
                <div
                    class="mybets-scoreboard_stats-column"
                    [ngClass]="stat.statClasses"
                    [ngStyle]="{ display: stat.isVisible && stat.isEnabled ? 'flex' : 'none' }">
                    @if (stat.isVisible && stat.isEnabled) {
                        <div class="cell highlight">
                            <ms-stats-value [value]="stat.player1" />
                        </div>
                        <div class="cell highlight">
                            <ms-stats-value [value]="stat.player2" />
                        </div>
                        <div class="cell">
                            @if (stat.icon) {
                                <vn-icon size="12" [ngClass]="stat.statClasses" [name]="stat.icon" />
                            }
                        </div>
                    }
                </div>
            }
        </div>
        @if (isExpandable()) {
            <div class="mybets-scoreboard_stats-expand" (click)="onExpandCollapse($event)">
                <span *msShowInEpcot="false" [ngClass]="{ active: isExpanded() }">
                    <vn-icon class="mybets-scoreboard-stats-icon" name="sports-stats-active" size="12" />
                </span>
                <span *msShowInEpcot="true" [ngClass]="">
                    <vn-icon class="mybets-scoreboard-stats-icon active" size="14" [name]="isExpanded() ? 'sports-stats-active' : 'sports-stats'" />
                </span>
                <span></span>
            </div>
        }
    </div>
}
